export default __webpack_public_path__ + "static/media/about-right.8ceeb0b4.jpg";